
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-1 -2 14 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 0C2.686 0 0 2.782 0 6.213 0 9.645 4.089 16 6 16c1.911 0 6-6.355 6-9.787C12 2.782 9.314 0 6 0zm0 9.061c-1.744 0-3.158-1.464-3.158-3.27C2.842 3.984 4.256 2.52 6 2.52s3.158 1.464 3.158 3.27c0 1.807-1.414 3.271-3.158 3.271z"}})])
          )
        }
      }
    